class Collapse {

    constructor() {}

    registerChangeHandlers() {
          $('[data-collapse-control]')
            .off('change', this.changeHandler.bind(this))
            .on('change', this.changeHandler.bind(this))
            .trigger('change');
    }

    changeHandler(e) {

        const $target = $(e.currentTarget);
        const group = $target.data('collapse-control');

        // Ignore this control if other control in group was checked
        if (group !== true && ($target.is('[type=checkbox]') || $target.is('[type=radio]'))) {
            if ($target.val() !== '1') {
                const $otherChecked = $(`[data-collapse-control="${group}"][value="1"]:checked`);
                if ($otherChecked.length) {
                    $otherChecked.trigger('change');
                    return;
                }
            }
        }

        let val = $target.val();

        if ($target.is('[type=checkbox]') && !$target.is(':checked')) {
            val = 'NOT_SET';
        } else if ($target.is('[type=radio]')) {
            val = $(`[name="${e.target.name}"]:checked`).val() || 'NOT_SET';
        }

        const selector = `[data-collapse-target="#${e.target.id}"],[data-collapse-target="[name='${e.target.name}']"],[data-collapse-target-group='${group}']`;
        const $containers = document.querySelectorAll(selector);

        $containers.forEach(container => {

            const $container = $(container);
            const values = ($container.data('collapse-values') || '');
            let hasMatch = false;

            if (values === '' && !val) {
                hasMatch = true;
            }
            // Matcher function
            else if (values.constructor === Object) {
                let matcher = window;
                const parts = values.matcher.split('.');

                parts.forEach(part => {
                    matcher = part;
                });
                hasMatch = matcher(val);
            }
            // Value list
            else {
                const valueParts = ('' + values).split(',');

                for (let i = 0; i < valueParts.length; i++) {
                    hasMatch = this.checkForMatch(valueParts[i], val);
                    if (hasMatch) {
                        break;
                    }
                }
            }

            if (hasMatch) {
                $container
                    .addClass('in')
                    .find(':input')
                    .prop('disabled', false)
                ;
                $container.trigger('collapse:show')
            } else {
                $container
                    .removeClass('in')
                    .find(':input')
                    .prop('disabled', true)
                ;
                $container.trigger('collapse:hide')
            }
        });
    }

    checkForMatch(subject, value) {
        if (subject.substr(0, 1) === '!') {
            return subject.substr(1) !== value;
        }

        return subject === value;
    }

}
